/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="userKey" placeholder="输入用户名/手机号"></el-input>
      </el-form-item>

      <!-- <el-form-item>
        <el-select size="small" v-model="status" placeholder="请选择">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getFinanceList(1)">搜索</el-button>
      </el-form-item>


    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="id" label="id" width="60">
      </el-table-column>
      <el-table-column sortable prop="title" label="标题" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="addTime" label="头像" width="100">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px;border-radius: 50px;" :src="$adminImageUrl(scope.row.headPortrait)"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="username" label="用户" width="100">
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" width="100">
      </el-table-column>
      <el-table-column sortable prop="type" label="支出/收入" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.type == 0">支出</div>
          <div v-if="scope.row.type == 1">收入</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="otherType" label="类型" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.otherType == 0">充值</div>
          <div v-if="scope.row.otherType == 1">退款</div>
          <div v-if="scope.row.otherType == 2">购买商品</div>
          <div v-if="scope.row.otherType == 3">提现</div>
          <div v-if="scope.row.otherType == 4">提现失败</div>
          <div v-if="scope.row.otherType == 5">销售商品</div>
          <div v-if="scope.row.otherType == 6">缴纳押金</div>
          <div v-if="scope.row.otherType == 7">退款押金</div>


        </template>
      </el-table-column>

      <el-table-column sortable prop="goodsPrice" label="金额" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.money / 100 }}</div>
        </template>

      </el-table-column>


      <el-table-column sortable prop="addTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { getFinanceList, getOrderDetails, setOrderRefund } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',

      userKey: "",
      status: 0,
      payType: [
        { key: '请选择', value: 0 },
        { key: '充值', value: 1 },
        { key: '退款', value: 2 },
        { key: '购买商品', value: 3 },
        { key: '提现', value: 4 },
        { key: '提现失败', value: 5 },
        { key: '销售商品', value: 6 },
        { key: '缴纳押金', value: 7 },
        { key: '退款押金', value: 8 }


      ],

      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },

      listData: [], //用户数据
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },



    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getFinanceList(1)


  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getMainImg(goodsData) {

      return JSON.parse(JSON.parse(goodsData).carousel)[0];

    },
    // 获取订单列表
    getFinanceList(page) {
      this.loading = true;
      var parameter = {
        userKey: this.userKey,
        type: this.status - 1,
        page: (page - 1) * 20,
      };
      console.log("parameter",parameter)
      getFinanceList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.orderInfo = row;
      this.getOrderDetails()
    },


    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 

 



// WEBPACK FOOTER //
// src/views/finance/Finance.vue